// extracted by mini-css-extract-plugin
export default {"root":"ProjectTableItem_root__rmQjx","name":"ProjectTableItem_name__gGSKR","icon":"ProjectTableItem_icon__QzVqx"};